import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecenziiComponent } from './recenzii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        RecenziiComponent
    ],
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, MaterialModule
    ],
    exports: [
        RecenziiComponent
    ],
})
export class RecenziiModule { }
